// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Beautiful Design for User Information Dashboard */

/* Import Google Fonts for better typography */

/* CSS Variables for consistent theming */
:root {
  --primary-color: #e2e8f0;
  --primary-light: #f1f5f9;
  --primary-dark: #cbd5e1;
  --secondary-color: #F3903F;
  --accent-color: #F3903F;
  --success-color: #10b981;
  --warning-color: #f59e0b;
  --error-color: #ef4444;
  --text-primary: #1e293b;
  --text-secondary: #475569;
  --text-muted: #64748b;
  --icon-color: #64748b;
  --bg-primary: #ffffff;
  --bg-secondary: #f8fafc;
  --bg-tertiary: #f1f5f9;
  --border-color: #e2e8f0;
  --border-light: #f1f5f9;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --gradient-primary: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  --gradient-secondary: linear-gradient(135deg, #F3903F 0%, #e67e22 100%);
  --gradient-success: linear-gradient(135deg, #10b981 0%, #059669 100%);
  --gradient-warning: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

/* Global Styles */
* {
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.6;
  color: var(--text-primary);
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

.root {
  margin-top: 130px;
  padding: 0.5rem;
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}

/* Dashboard Header */
.dashboard-header {
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1rem;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
  width: 100%;
}

.dashboard-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--gradient-secondary);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  width: 100%;
}

.dashboard-title {
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--gradient-secondary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-icon {
  font-size: 1.75rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.tab-navigation {
  display: flex;
  gap: 0.25rem;
  background: var(--bg-secondary);
  padding: 0.375rem;
  border-radius: 10px;
  box-shadow: var(--shadow-sm);
}

.tab-button {
  padding: 0.625rem 1.25rem;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.8rem;
}

.tab-button:hover {
  color: var(--text-primary);
  background: var(--bg-tertiary);
}

.tab-button.active {
  background: var(--gradient-secondary);
  color: white;
  box-shadow: var(--shadow-sm);
}

/* Beautiful Card Design */
.info-card {
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1rem;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
}

.info-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--gradient-secondary);
}

.info-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 15px 30px -10px rgba(0, 0, 0, 0.1);
}

/* Section Titles with Beautiful Design */
.section-title {
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  position: relative;
  padding-bottom: 0.5rem;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background: var(--gradient-secondary);
  border-radius: 1px;
}

.section-icon {
  font-size: 1.25rem;
  color: var(--icon-color);
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

/* Count badges */
.framework-count,
.services-count {
  background: var(--bg-secondary);
  color: var(--text-secondary);
  padding: 0.125rem 0.5rem;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 600;
  margin-left: 0.375rem;
  border: 1px solid var(--border-light);
}

/* Organization Name */
.org-name {
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

/* Grid Layout */
.grid-layout {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 0.75rem;
  width: 100%;
}

.info-column {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

/* Info Items */
.info-item {
  background: var(--bg-secondary);
  padding: 0.75rem 0.875rem;
  border-radius: 8px;
  border-left: 2px solid var(--secondary-color);
  transition: all 0.2s ease;
}

.info-item:hover {
  background: var(--bg-tertiary);
  transform: translateX(2px);
}

.info-item strong {
  color: var(--text-primary);
  font-weight: 600;
  display: block;
  margin-bottom: 0.125rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.info-item span {
  color: var(--text-secondary);
  font-size: 0.875rem;
}

/* Framework Cards */
.framework-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 0.75rem;
  width: 100%;
}

.framework-card {
  background: var(--bg-primary);
  border-radius: 10px;
  padding: 1rem;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-light);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.framework-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--gradient-secondary);
}

.framework-card:hover {
  transform: translateY(-2px) scale(1.005);
  box-shadow: var(--shadow-md);
}

.framework-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  gap: 0.75rem;
}

.framework-icon {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--icon-color);
  font-weight: 600;
  font-size: 1rem;
  border: 1px solid var(--border-light);
}

.framework-header h4 {
  color: var(--text-primary);
  font-weight: 600;
  font-size: 1.5rem;
  margin: 0;
}

.framework-reason {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.5;
  margin: 0 0 0.75rem 0;
}

.framework-footer {
  border-top: 1px solid var(--border-light);
  padding-top: 0.5rem;
  margin-top: auto;
}

.framework-id {
  color: var(--text-muted);
  font-size: 0.65rem;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}

/* Controls Section */
.controls-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.controls-stats {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.controls-count {
  background: var(--bg-secondary);
  color: var(--text-secondary);
  padding: 0.375rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid var(--border-light);
}

.status-badge {
  padding: 0.375rem 0.75rem;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: var(--shadow-sm);
  transition: all 0.2s ease;
}

.status-badge.complete {
  background: var(--gradient-success);
  color: white;
}

.status-badge.pending {
  background: var(--gradient-warning);
  color: white;
}

.status-badge:hover {
  transform: scale(1.01);
}

/* Control Groups */
.control-group {
  margin-bottom: 1.25rem;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  background: var(--bg-primary);
}

.group-header {
  background: var(--bg-secondary);
  color: var(--text-primary);
  padding: 0.875rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid var(--border-light);
}

.group-header h4 {
  margin: 0;
  font-weight: 600;
  font-size: 1.25rem;
  color: var(--text-primary);
}

.owner-badge {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid var(--border-light);
}

.group-description {
  background: var(--bg-secondary);
  padding: 0.875rem 1rem;
  border-bottom: 1px solid var(--border-light);
}

.group-description p {
  margin: 0.25rem 0;
  color: var(--text-secondary);
  line-height: 1.4;
  font-size: 0.85rem;
}

/* Table Styling */
.table-container {
  overflow-x: auto;
  border-radius: 0 0 10px 10px;
  width: 100%;
}

.controls-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--bg-primary);
}

.controls-table th {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  text-align: left;
  padding: 0.875rem 0.75rem;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid var(--border-color);
}

.controls-table td {
  padding: 0.875rem 0.75rem;
  border-bottom: 1px solid var(--border-light);
  vertical-align: top;
  transition: background-color 0.2s ease;
}

.controls-table tr:hover {
  background-color: var(--bg-secondary);
}

.controls-table tr:last-child td {
  border-bottom: none;
}

/* Control Row Styling */
.control-name-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.control-icon {
  width: 28px;
  height: 28px;
  background: var(--bg-tertiary);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--icon-color);
  font-weight: 600;
  font-size: 0.75rem;
  flex-shrink: 0;
  border: 1px solid var(--border-light);
}

.control-code {
  font-weight: 600;
  color: var(--text-primary);
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.75rem;
}

.control-name {
  font-weight: 500;
  color: var(--text-primary);
}

.control-description {
  color: var(--text-secondary);
  line-height: 1.4;
  max-width: 250px;
  font-size: 0.85rem;
}

.control-owner {
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 0.85rem;
}

/* Type Badges */
.type-badge {
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: var(--shadow-sm);
}

.type-badge.mandatory {
  background: var(--gradient-success);
  color: white;
}

.type-badge.optional {
  background: var(--gradient-warning);
  color: white;
}

/* Services List */
.services-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
  width: 100%;
}

.service-item {
  background: var(--bg-secondary);
  padding: 0.75rem 0.875rem;
  border-radius: 8px;
  color: var(--text-secondary);
  position: relative;
  padding-left: 2.25rem;
  line-height: 1.4;
  transition: all 0.2s ease;
  border-left: 2px solid var(--secondary-color);
}

.service-item:hover {
  background: var(--bg-tertiary);
  transform: translateX(2px);
}

.service-bullet {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background: var(--secondary-color);
  border-radius: 50%;
  box-shadow: var(--shadow-sm);
}

/* Loading States */
.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 40vh;
  gap: 1rem;
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 2rem;
  box-shadow: var(--shadow-md);
  width: 100%;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 2px solid var(--border-light);
  border-top: 2px solid var(--secondary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  box-shadow: var(--shadow-sm);
}

.loading-container p {
  color: var(--text-secondary);
  font-size: 0.95rem;
  font-weight: 500;
}

/* Loading dots animation */
.loading-dots {
  display: flex;
  gap: 0.25rem;
}

.loading-dots span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--secondary-color);
  animation: dots 1.4s infinite ease-in-out;
}

.loading-dots span:nth-child(1) { animation-delay: -0.32s; }
.loading-dots span:nth-child(2) { animation-delay: -0.16s; }

@keyframes dots {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Error States */
.error-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border-radius: 10px;
  margin: 0.75rem 0;
  color: var(--error-color);
  border-left: 2px solid var(--error-color);
  box-shadow: var(--shadow-sm);
  width: 100%;
}

.error-icon {
  width: 36px;
  height: 36px;
  background: var(--error-color);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1rem;
  box-shadow: var(--shadow-sm);
}

.error-content {
  flex: 1 1;
}

.error-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.error-message {
  font-weight: 500;
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
}

/* Buttons */
.retry-button,
.refresh-button {
  background: var(--gradient-secondary);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: var(--shadow-sm);
  font-size: 0.85rem;
}

.retry-button:hover,
.refresh-button:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

/* Empty States */
.empty-state {
  padding: 2rem 1.25rem;
  text-align: center;
  color: var(--text-muted);
  background: var(--bg-secondary);
  border-radius: 10px;
  border: 2px dashed var(--border-color);
  width: 100%;
}

.empty-icon {
  font-size: 2rem;
  margin-bottom: 0.75rem;
  opacity: 0.5;
}

.empty-state h3 {
  color: var(--text-primary);
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.empty-state p {
  font-size: 0.95rem;
  font-weight: 500;
  margin: 0 0 1rem 0;
}

/* Dashboard Footer */
.dashboard-footer {
  background: var(--bg-primary);
  border-radius: 10px;
  padding: 1rem 1.25rem;
  margin-top: 1rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.75rem;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-light);
  width: 100%;
}

.dashboard-footer p {
  margin: 0.125rem 0;
}

.footer-actions {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.assessment-link {
  padding: 0.75rem 1.5rem;
  background: var(--gradient-secondary);
  color: white;
  border: none;
  border-radius: var(--border-radius);
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.875rem;
  text-decoration: none;
  display: inline-block;
}

.assessment-link:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* Animations */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Apply animations to cards */
.info-card {
  animation: fadeIn 0.4s ease-out;
}

.framework-card {
  animation: slideIn 0.4s ease-out;
}

/* Responsive Design */
@media (max-width: 768px) {
  .root {
    padding: 0.25rem;
    margin-top: 100px;
  }
  
  .dashboard-header {
    padding: 1rem;
  }
  
  .header-content {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .dashboard-title {
    font-size: 1.25rem;
  }
  
  .tab-navigation {
    width: 100%;
    justify-content: center;
  }
  
  .info-card {
    padding: 1rem;
    margin-bottom: 1rem;
  }
  
  .grid-layout {
    grid-template-columns: 1fr;
    gap: 0.625rem;
  }
  
  .framework-grid {
    grid-template-columns: 1fr;
    gap: 0.625rem;
  }
  
  .services-list {
    grid-template-columns: 1fr;
  }
  
  .controls-header {
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-start;
  }
  
  .controls-stats {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .org-name {
    font-size: 1.25rem;
  }
  
  .section-title {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .root {
    padding: 0.125rem;
  }
  
  .dashboard-header {
    padding: 0.75rem;
  }
  
  .info-card {
    padding: 0.75rem;
    border-radius: 8px;
  }
  
  .framework-card {
    padding: 0.75rem;
  }
  
  .controls-table th,
  .controls-table td {
    padding: 0.5rem 0.375rem;
    font-size: 0.75rem;
  }
  
  .tab-button {
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  :root {
    --bg-primary: #1f2937;
    --bg-secondary: #111827;
    --bg-tertiary: #374151;
    --text-primary: #f9fafb;
    --text-secondary: #d1d5db;
    --text-muted: #9ca3af;
    --icon-color: #9ca3af;
    --border-color: #374151;
    --border-light: #4b5563;
  }
  
  body {
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
  }
}

/* Custom scrollbar */
.table-container::-webkit-scrollbar {
  height: 4px;
}

.table-container::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 2px;
}

.table-container::-webkit-scrollbar-thumb {
  background: var(--secondary-color);
  border-radius: 2px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: var(--accent-color);
}
    `, "",{"version":3,"sources":["webpack://./src/pages/frameWork/style.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D,8CAA8C;;AAG9C,yCAAyC;AACzC;EACE,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;EACtF,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,qEAAqE;AACvE;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;AACxB;;AAEA;EACE,uFAAuF;EACvF,gBAAgB;EAChB,0BAA0B;EAC1B,6DAA6D;EAC7D,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;EACrC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,yCAAyC;AACzC;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA,iBAAiB;AACjB;;EAEE,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,qCAAqC;EACrC,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,4CAA4C;EAC5C,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA,kCAAkC,uBAAuB,EAAE;AAC3D,kCAAkC,uBAAuB,EAAE;;AAE3D;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;;EAEE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;EAC5B,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,8BAA8B;AAC9B;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,6DAA6D;EAC/D;AACF;;AAEA,qBAAqB;AACrB;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["/* Modern Beautiful Design for User Information Dashboard */\n\n/* Import Google Fonts for better typography */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* CSS Variables for consistent theming */\n:root {\n  --primary-color: #e2e8f0;\n  --primary-light: #f1f5f9;\n  --primary-dark: #cbd5e1;\n  --secondary-color: #F3903F;\n  --accent-color: #F3903F;\n  --success-color: #10b981;\n  --warning-color: #f59e0b;\n  --error-color: #ef4444;\n  --text-primary: #1e293b;\n  --text-secondary: #475569;\n  --text-muted: #64748b;\n  --icon-color: #64748b;\n  --bg-primary: #ffffff;\n  --bg-secondary: #f8fafc;\n  --bg-tertiary: #f1f5f9;\n  --border-color: #e2e8f0;\n  --border-light: #f1f5f9;\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  --gradient-primary: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  --gradient-secondary: linear-gradient(135deg, #F3903F 0%, #e67e22 100%);\n  --gradient-success: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  --gradient-warning: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n}\n\n/* Global Styles */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  line-height: 1.6;\n  color: var(--text-primary);\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  min-height: 100vh;\n  margin: 0;\n  padding: 0;\n}\n\n.root {\n  margin-top: 130px;\n  padding: 0.5rem;\n  width: 100%;\n  max-width: 100%;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n/* Dashboard Header */\n.dashboard-header {\n  background: var(--bg-primary);\n  border-radius: 12px;\n  padding: 1.25rem;\n  margin-bottom: 1rem;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-light);\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n\n.dashboard-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: var(--gradient-secondary);\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.dashboard-title {\n  color: var(--text-primary);\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: var(--gradient-secondary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.title-icon {\n  font-size: 1.75rem;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n}\n\n.tab-navigation {\n  display: flex;\n  gap: 0.25rem;\n  background: var(--bg-secondary);\n  padding: 0.375rem;\n  border-radius: 10px;\n  box-shadow: var(--shadow-sm);\n}\n\n.tab-button {\n  padding: 0.625rem 1.25rem;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  font-weight: 500;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.8rem;\n}\n\n.tab-button:hover {\n  color: var(--text-primary);\n  background: var(--bg-tertiary);\n}\n\n.tab-button.active {\n  background: var(--gradient-secondary);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n/* Beautiful Card Design */\n.info-card {\n  background: var(--bg-primary);\n  border-radius: 12px;\n  padding: 1.25rem;\n  margin-bottom: 1rem;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-light);\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 100%;\n}\n\n.info-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: var(--gradient-secondary);\n}\n\n.info-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 15px 30px -10px rgba(0, 0, 0, 0.1);\n}\n\n/* Section Titles with Beautiful Design */\n.section-title {\n  color: var(--text-primary);\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  position: relative;\n  padding-bottom: 0.5rem;\n}\n\n.section-title::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 40px;\n  height: 2px;\n  background: var(--gradient-secondary);\n  border-radius: 1px;\n}\n\n.section-icon {\n  font-size: 1.25rem;\n  color: var(--icon-color);\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));\n}\n\n/* Count badges */\n.framework-count,\n.services-count {\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  padding: 0.125rem 0.5rem;\n  border-radius: 8px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  margin-left: 0.375rem;\n  border: 1px solid var(--border-light);\n}\n\n/* Organization Name */\n.org-name {\n  color: var(--text-primary);\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n\n/* Grid Layout */\n.grid-layout {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.info-column {\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n}\n\n/* Info Items */\n.info-item {\n  background: var(--bg-secondary);\n  padding: 0.75rem 0.875rem;\n  border-radius: 8px;\n  border-left: 2px solid var(--secondary-color);\n  transition: all 0.2s ease;\n}\n\n.info-item:hover {\n  background: var(--bg-tertiary);\n  transform: translateX(2px);\n}\n\n.info-item strong {\n  color: var(--text-primary);\n  font-weight: 600;\n  display: block;\n  margin-bottom: 0.125rem;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.info-item span {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n}\n\n/* Framework Cards */\n.framework-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.framework-card {\n  background: var(--bg-primary);\n  border-radius: 10px;\n  padding: 1rem;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-light);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.framework-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: var(--gradient-secondary);\n}\n\n.framework-card:hover {\n  transform: translateY(-2px) scale(1.005);\n  box-shadow: var(--shadow-md);\n}\n\n.framework-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  gap: 0.75rem;\n}\n\n.framework-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 6px;\n  background: var(--bg-tertiary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--icon-color);\n  font-weight: 600;\n  font-size: 1rem;\n  border: 1px solid var(--border-light);\n}\n\n.framework-header h4 {\n  color: var(--text-primary);\n  font-weight: 600;\n  font-size: 1.5rem;\n  margin: 0;\n}\n\n.framework-reason {\n  color: var(--text-secondary);\n  font-size: 1rem;\n  line-height: 1.5;\n  margin: 0 0 0.75rem 0;\n}\n\n.framework-footer {\n  border-top: 1px solid var(--border-light);\n  padding-top: 0.5rem;\n  margin-top: auto;\n}\n\n.framework-id {\n  color: var(--text-muted);\n  font-size: 0.65rem;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n}\n\n/* Controls Section */\n.controls-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.controls-stats {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.controls-count {\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  padding: 0.375rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  border: 1px solid var(--border-light);\n}\n\n.status-badge {\n  padding: 0.375rem 0.75rem;\n  border-radius: 16px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  box-shadow: var(--shadow-sm);\n  transition: all 0.2s ease;\n}\n\n.status-badge.complete {\n  background: var(--gradient-success);\n  color: white;\n}\n\n.status-badge.pending {\n  background: var(--gradient-warning);\n  color: white;\n}\n\n.status-badge:hover {\n  transform: scale(1.01);\n}\n\n/* Control Groups */\n.control-group {\n  margin-bottom: 1.25rem;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  background: var(--bg-primary);\n}\n\n.group-header {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  padding: 0.875rem 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2px solid var(--border-light);\n}\n\n.group-header h4 {\n  margin: 0;\n  font-weight: 600;\n  font-size: 1.25rem;\n  color: var(--text-primary);\n}\n\n.owner-badge {\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  padding: 0.125rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  border: 1px solid var(--border-light);\n}\n\n.group-description {\n  background: var(--bg-secondary);\n  padding: 0.875rem 1rem;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.group-description p {\n  margin: 0.25rem 0;\n  color: var(--text-secondary);\n  line-height: 1.4;\n  font-size: 0.85rem;\n}\n\n/* Table Styling */\n.table-container {\n  overflow-x: auto;\n  border-radius: 0 0 10px 10px;\n  width: 100%;\n}\n\n.controls-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--bg-primary);\n}\n\n.controls-table th {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  text-align: left;\n  padding: 0.875rem 0.75rem;\n  font-weight: 600;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 2px solid var(--border-color);\n}\n\n.controls-table td {\n  padding: 0.875rem 0.75rem;\n  border-bottom: 1px solid var(--border-light);\n  vertical-align: top;\n  transition: background-color 0.2s ease;\n}\n\n.controls-table tr:hover {\n  background-color: var(--bg-secondary);\n}\n\n.controls-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Control Row Styling */\n.control-name-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.control-icon {\n  width: 28px;\n  height: 28px;\n  background: var(--bg-tertiary);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--icon-color);\n  font-weight: 600;\n  font-size: 0.75rem;\n  flex-shrink: 0;\n  border: 1px solid var(--border-light);\n}\n\n.control-code {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 0.75rem;\n}\n\n.control-name {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.control-description {\n  color: var(--text-secondary);\n  line-height: 1.4;\n  max-width: 250px;\n  font-size: 0.85rem;\n}\n\n.control-owner {\n  color: var(--text-secondary);\n  font-weight: 500;\n  font-size: 0.85rem;\n}\n\n/* Type Badges */\n.type-badge {\n  padding: 0.125rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  box-shadow: var(--shadow-sm);\n}\n\n.type-badge.mandatory {\n  background: var(--gradient-success);\n  color: white;\n}\n\n.type-badge.optional {\n  background: var(--gradient-warning);\n  color: white;\n}\n\n/* Services List */\n.services-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.service-item {\n  background: var(--bg-secondary);\n  padding: 0.75rem 0.875rem;\n  border-radius: 8px;\n  color: var(--text-secondary);\n  position: relative;\n  padding-left: 2.25rem;\n  line-height: 1.4;\n  transition: all 0.2s ease;\n  border-left: 2px solid var(--secondary-color);\n}\n\n.service-item:hover {\n  background: var(--bg-tertiary);\n  transform: translateX(2px);\n}\n\n.service-bullet {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n  height: 8px;\n  background: var(--secondary-color);\n  border-radius: 50%;\n  box-shadow: var(--shadow-sm);\n}\n\n/* Loading States */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 40vh;\n  gap: 1rem;\n  background: var(--bg-primary);\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: var(--shadow-md);\n  width: 100%;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 2px solid var(--border-light);\n  border-top: 2px solid var(--secondary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  box-shadow: var(--shadow-sm);\n}\n\n.loading-container p {\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n/* Loading dots animation */\n.loading-dots {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.loading-dots span {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--secondary-color);\n  animation: dots 1.4s infinite ease-in-out;\n}\n\n.loading-dots span:nth-child(1) { animation-delay: -0.32s; }\n.loading-dots span:nth-child(2) { animation-delay: -0.16s; }\n\n@keyframes dots {\n  0%, 80%, 100% {\n    transform: scale(0);\n    opacity: 0.5;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Error States */\n.error-container {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.25rem;\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  border-radius: 10px;\n  margin: 0.75rem 0;\n  color: var(--error-color);\n  border-left: 2px solid var(--error-color);\n  box-shadow: var(--shadow-sm);\n  width: 100%;\n}\n\n.error-icon {\n  width: 36px;\n  height: 36px;\n  background: var(--error-color);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 1rem;\n  box-shadow: var(--shadow-sm);\n}\n\n.error-content {\n  flex: 1;\n}\n\n.error-title {\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.error-message {\n  font-weight: 500;\n  font-size: 0.9rem;\n  margin-bottom: 0.75rem;\n}\n\n/* Buttons */\n.retry-button,\n.refresh-button {\n  background: var(--gradient-secondary);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: var(--shadow-sm);\n  font-size: 0.85rem;\n}\n\n.retry-button:hover,\n.refresh-button:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Empty States */\n.empty-state {\n  padding: 2rem 1.25rem;\n  text-align: center;\n  color: var(--text-muted);\n  background: var(--bg-secondary);\n  border-radius: 10px;\n  border: 2px dashed var(--border-color);\n  width: 100%;\n}\n\n.empty-icon {\n  font-size: 2rem;\n  margin-bottom: 0.75rem;\n  opacity: 0.5;\n}\n\n.empty-state h3 {\n  color: var(--text-primary);\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.empty-state p {\n  font-size: 0.95rem;\n  font-weight: 500;\n  margin: 0 0 1rem 0;\n}\n\n/* Dashboard Footer */\n.dashboard-footer {\n  background: var(--bg-primary);\n  border-radius: 10px;\n  padding: 1rem 1.25rem;\n  margin-top: 1rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-light);\n  width: 100%;\n}\n\n.dashboard-footer p {\n  margin: 0.125rem 0;\n}\n\n.footer-actions {\n  margin-top: 1rem;\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.assessment-link {\n  padding: 0.75rem 1.5rem;\n  background: var(--gradient-secondary);\n  color: white;\n  border: none;\n  border-radius: var(--border-radius);\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  font-size: 0.875rem;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.assessment-link:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Animations */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Apply animations to cards */\n.info-card {\n  animation: fadeIn 0.4s ease-out;\n}\n\n.framework-card {\n  animation: slideIn 0.4s ease-out;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .root {\n    padding: 0.25rem;\n    margin-top: 100px;\n  }\n  \n  .dashboard-header {\n    padding: 1rem;\n  }\n  \n  .header-content {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .dashboard-title {\n    font-size: 1.25rem;\n  }\n  \n  .tab-navigation {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .info-card {\n    padding: 1rem;\n    margin-bottom: 1rem;\n  }\n  \n  .grid-layout {\n    grid-template-columns: 1fr;\n    gap: 0.625rem;\n  }\n  \n  .framework-grid {\n    grid-template-columns: 1fr;\n    gap: 0.625rem;\n  }\n  \n  .services-list {\n    grid-template-columns: 1fr;\n  }\n  \n  .controls-header {\n    flex-direction: column;\n    gap: 0.75rem;\n    align-items: flex-start;\n  }\n  \n  .controls-stats {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .org-name {\n    font-size: 1.25rem;\n  }\n  \n  .section-title {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .root {\n    padding: 0.125rem;\n  }\n  \n  .dashboard-header {\n    padding: 0.75rem;\n  }\n  \n  .info-card {\n    padding: 0.75rem;\n    border-radius: 8px;\n  }\n  \n  .framework-card {\n    padding: 0.75rem;\n  }\n  \n  .controls-table th,\n  .controls-table td {\n    padding: 0.5rem 0.375rem;\n    font-size: 0.75rem;\n  }\n  \n  .tab-button {\n    padding: 0.375rem 0.75rem;\n    font-size: 0.75rem;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  :root {\n    --bg-primary: #1f2937;\n    --bg-secondary: #111827;\n    --bg-tertiary: #374151;\n    --text-primary: #f9fafb;\n    --text-secondary: #d1d5db;\n    --text-muted: #9ca3af;\n    --icon-color: #9ca3af;\n    --border-color: #374151;\n    --border-light: #4b5563;\n  }\n  \n  body {\n    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\n  }\n}\n\n/* Custom scrollbar */\n.table-container::-webkit-scrollbar {\n  height: 4px;\n}\n\n.table-container::-webkit-scrollbar-track {\n  background: var(--bg-tertiary);\n  border-radius: 2px;\n}\n\n.table-container::-webkit-scrollbar-thumb {\n  background: var(--secondary-color);\n  border-radius: 2px;\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n  background: var(--accent-color);\n}\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
